export default __webpack_public_path__ + "static/media/navbar_logo_mob.f05af620.svg";